
import { mapState } from 'vuex';
import PurchasePurpose from '@/enums/PurchasePurpose';

export default {
  i18nComponentKey: 'ReviewsNew.components.PendingReviews',
  name: 'PendingReviews',
  props: {
    subOrders: { type: Array, required: true }
  },
  computed: {
    ...mapState('widget', ['widget']),
    ...mapState('reviewSettings', ['reviewSettings']),
    PurchasePurpose: () => PurchasePurpose
  },
  methods: {
    showProductOptions(subOrder) {
      return (
        this.reviewSettings.show_options &&
        Object.keys(subOrder.product_options).length > 0
      );
    }
  }
};
